import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: SPACES.xxl,
    overflow: 'auto',

    minHeight: 360,
    maxHeight: '80vh',
    [theme.breakpoints.down('tablet')]: {
      width: 320,
    },
    [theme.breakpoints.up('tablet')]: {
      width: 400,
    },

    scrollbarColor: theme.palette.custom.grey2,
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.custom.grey2,
      borderRadius: '10px',
    },
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: SPACES.xl,
  },
  buttonWrapper: {
    width: '100%',
  },
  title: {
    '&&': {
      fontSize: FONTS.SIZES.xl,
      fontWeight: FONTS.WEIGHTS.bold,
      marginBottom: SPACES.xl,

      textAlign: 'center',
    },
  },
  itemTitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,

      '&:first-letter': {
        textTransform: 'uppercase',
      },
    },
  },
  relationsTitle: {
    '&&': {
      fontSize: FONTS.SIZES.m,
    },
  },
}))
